import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import SliderNew from '@components/slider-new'
import CategorySliderCard from '@components/category-slider-card'
import useStyles from './category-slider.styles'

const CategorySlider = (props) => {
  const {
    schoolsHeadline,
    schoolsSubtitle,
    schoolCategories,
    schoolsCollection,
  } = props

  const initialSchools = schoolsCollection?.items || null

  const styles = useStyles()
  const [selectedCategory, setSelectedCategory] = useState('')
  const [schools, setSchools] = useState(initialSchools)

  const handleAllCategoriesClick = () => {
    setSelectedCategory('')
    setSchools(initialSchools)
  }

  const handleCategoryClick = (clickedCategory) => {
    if (clickedCategory === selectedCategory) {
      handleAllCategoriesClick()
    } else {
      setSelectedCategory(clickedCategory)
      if (schoolsCollection?.items.length > 0) {
        const filteredSchools = schoolsCollection?.items.filter((schoolObj) => {
          return schoolObj.series === clickedCategory
        })
        setSchools(filteredSchools)
      }
    }
  }

  return (
    <div className={styles.root}>
      <Container>
        <Typography className={styles.headline} variant="h3">{schoolsHeadline}</Typography>
        <Typography className={styles.subtitle} variant="body1">{schoolsSubtitle}</Typography>
        {schoolCategories?.length > 0 && (
          <>
            <Box
              className={styles.categoryTagsRow}
              role="group"
              aria-label={`${schoolsHeadline} single select filter buttons`}
            >
              <Button
                onClick={handleAllCategoriesClick}
                className={`${styles.categoryTags} ${selectedCategory === '' ? styles.active : ''}`}
                aria-pressed={selectedCategory === ''}
              >
                All Universities
              </Button>
              {schoolCategories.map(item => (
                <Button
                  onClick={() => handleCategoryClick(item)}
                  key={item}
                  className={`${styles.categoryTags} ${item === selectedCategory ? styles.active : ''}`}
                  aria-pressed={selectedCategory === item}
                >{item}
                </Button>
              ))}
            </Box>
            <Box className={styles.divider} />
          </>
        )}
        {schools?.length > 0 ? (
          <div data-testid="schools-slider" className={styles.sliderContainer}>
            <SliderNew className={styles.slider}>
              {schools.map((info) => {
                return <CategorySliderCard {...info} key={info.headline} />
              })}
            </SliderNew>
          </div>
        ) : (
          <div
            data-testid="no-results-page"
            className={styles.noResultsContainer}
          >
            <Typography variant="h5" className={styles.noResultsTitle}>
              No results in this category.
            </Typography>
            <Typography variant="body1" className={styles.noResultsBody}>
              Please select a different option.
            </Typography>
          </div>
        )}
      </Container>
    </div>
  )
}

CategorySlider.propTypes = {
  schoolsHeadline: PropTypes.string,
  schoolsSubtitle: PropTypes.string,
  schoolCategories: PropTypes.array,
  schoolsCollection: PropTypes.object,
}

CategorySlider.defaultProps = {}

export default CategorySlider
